import { useState } from "react";
import { createBranchLink } from "../helpers/BranchLink";

export default function SharePopup({ postId, onClose }) {
  const postUrl = `https://nhontrach-today.web.app/share?postId=${postId}`;

  const handleSystemShare = () => {
    if (navigator.share) {
      navigator.share({
        title: "Nhơn Trạch Hôm Nay",
        text: "Xem bài viết này trên Nhơn Trạch Hôm Nay",
        url: postUrl
      }).catch(err => console.log("Share canceled", err));
    } else {
      alert("Trình duyệt không hỗ trợ chia sẻ trực tiếp");
    }
    onClose();
  };

  const handleCopyLink = () => {
    navigator.clipboard.writeText(postUrl).then(() => {
      alert("Đã sao chép link!");
    });
    onClose();
  };

  const handleFacebookShare = () => {
    const fbUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(postUrl)}`;
    window.open(fbUrl, "_blank", "width=600,height=400");
    onClose();
  };

  return (
    <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-4 w-72 shadow-lg">
        <h3 className="text-lg font-semibold mb-4 text-center">Chia sẻ bài viết</h3>
        <div className="flex flex-col gap-3">
          <button
            onClick={(e) => {
              e.stopPropagation(); // chặn click lan lên post item
              handleSystemShare();
            }}
            className="px-4 py-2 bg-vietnam-primary text-white rounded hover:bg-vietnam-dark"
          >
            📱 Chia sẻ qua hệ thống
          </button>
          <button
            onClick={(e) => {
              e.stopPropagation(); // chặn click lan lên post item
              handleCopyLink();
            }}
            className="px-4 py-2 bg-gray-200 text-gray-800 rounded hover:bg-gray-300"
          >
            📋 Sao chép link
          </button>
          <button
            onClick={(e) => {
              e.stopPropagation(); // chặn click lan lên post item
              handleFacebookShare();
            }}
            className="px-4 py-2 bg-vietnam-dark text-white rounded hover:bg-red-900"
          >
            👍 Chia sẻ Facebook
          </button>
        </div>
        <button
          onClick={(e) => {
            e.stopPropagation(); // chặn click lan lên post item
            onClose();
          }}
          className="mt-4 w-full px-4 py-2 bg-red-500 text-white rounded hover:bg-red-600"
        >
          Đóng
        </button>
      </div>
    </div>
  );
}
